import fetch from 'fetch'
import consts from 'consts'

let key = 'commonconfig'

function isLocalStorageSupported () {
  var testKey = 'test'
  var storage = window.sessionStorage
  try {
    storage.setItem(testKey, 'testValue')
    storage.removeItem(testKey)
    return true
  } catch (error) {
    return false
  }
}

module.exports = {
  invalid: function () {
    sessionStorage.removeItem(key)
  },
  get: function () {
    if (!this.req) {
      this.req = new Promise(function (resolve, reject) {
        let storedData = sessionStorage.getItem(key)
        let localSupported = isLocalStorageSupported()
        if (storedData && localSupported) {
          resolve(JSON.parse(storedData))
        } else {
          console.log('request config')
          fetch({
            url: '/v1/config',
            data: {
              ct: consts.clientType
            }
          }).on('success', function (data) {
            if (localSupported) {
              sessionStorage.setItem(key, JSON.stringify(data))
            }
            resolve(data)
          }).on('error', function (err) {
            reject(err)
          })
        }
      })
    }
    return this.req
  }
}



// WEBPACK FOOTER //
// ./src/mods/commonconfig.js